import {
	Directive,
	Input,
	forwardRef
} from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator, ControlValueAccessor } from '@angular/forms';

import { ValidationRules } from 'rev-shared/util/ValidationRules';

@Directive({
	selector: '[vbUiUrl]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => VbUrlDirective),
		multi: true
	}],
	standalone: false
})
export class VbUrlDirective {
	@Input() public vbUrl: string[]; // optional array of valid schemes for the url. If not present, any scheme is allowed.

	public validate(control: AbstractControl): ValidationErrors {
		return (!control?.value || ValidationRules.checkUrl(control.value, this.vbUrl)) ?
			null :
			{ vbUrl: true };
	}
}
